import React from 'react';

export interface ThemeContextsProps {
  isDark: boolean;
  toggleDarkMode: () => void;
}

export interface ThemeContextsProviderProps {
  children: React.ReactNode;
}

export const ThemeContexts = React.createContext<ThemeContextsProps>({
  isDark: false,
  toggleDarkMode: () => {},
});

export const ThemeContextsProvider = ({
  children,
}: ThemeContextsProviderProps) => {
  const [isDark, setIsDark] = React.useState(false);

  React.useEffect(() => {
    // Check for saved theme preference or default to light mode
    const savedTheme = localStorage.getItem('theme');
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)',
    ).matches;

    if (savedTheme === 'dark' || (!savedTheme && prefersDark)) {
      setIsDark(true);
      document.documentElement.classList.add('dark');
    }
  }, []);

  const toggleDarkMode = () => {
    const newIsDark = !isDark;
    setIsDark(newIsDark);
    document.documentElement.classList.toggle('dark');
    localStorage.setItem('theme', newIsDark ? 'dark' : 'light');
  };

  return (
    <ThemeContexts.Provider value={{ isDark, toggleDarkMode }}>
      {children}
    </ThemeContexts.Provider>
  );
};
